import BASE_URL from "../../shared/base-url"

export const ROLE_ENDPOINT = {
  list: `${BASE_URL}/roles/get-roles`,
  permission: `${BASE_URL}/permissions/get-permissions`,
  role_permissions: `${BASE_URL}/roles/get-role-permissions`,
  create_role_permissions: `${BASE_URL}/roles/add-role-permission`,
  remove_role_permissions: `${BASE_URL}/roles/remove-role-permission`,
}
